/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/fee_types';
import '../common/payment';
import '../common/currency_codes';
import '../common/time';
import './feeplans_model';
import '../common/fee';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "feeplans": {
        "nested": {
          "CostPlusFeeRate": {
            "fields": {
              "marginBasisPoints": {
                "type": "uint32",
                "id": 1,
                "rule": "optional"
              },
              "marginCents": {
                "type": "uint32",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "feeplanRateId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "auditLogs": {
                "type": "squareup.feeplans.AuditLogEntry",
                "id": 4,
                "rule": "repeated"
              }
            }
          },
          "InterchangePlusFeeRate": {
            "fields": {
              "marginBasisPoints": {
                "type": "uint32",
                "id": 1,
                "rule": "optional"
              },
              "marginCents": {
                "type": "uint32",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "feeplanRateId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "auditLogs": {
                "type": "squareup.feeplans.AuditLogEntry",
                "id": 4,
                "rule": "repeated"
              }
            }
          },
          "SupplementalFeeRate": {
            "fields": {
              "marginBasisPoints": {
                "type": "uint32",
                "id": 1,
                "rule": "optional"
              },
              "marginCents": {
                "type": "uint32",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "feeplanRateId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "auditLogs": {
                "type": "squareup.feeplans.AuditLogEntry",
                "id": 4,
                "rule": "repeated"
              }
            }
          },
          "FeeRateConstraint": {
            "fields": {
              "type": {
                "type": "squareup.feeplans.FeeRateConstraint.Type",
                "id": 1,
                "rule": "optional"
              },
              "amountBaseUnit": {
                "type": "uint32",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "DO_NOT_USE": 0,
                  "MIN_FEE": 1,
                  "MAX_FEE": 2
                }
              }
            }
          },
          "TaxedFeeRate": {
            "fields": {
              "discountBasisPoints": {
                "type": "uint32",
                "id": 1,
                "rule": "optional"
              },
              "interchangeCents": {
                "type": "uint32",
                "id": 2,
                "rule": "optional"
              },
              "taxRateBasisPoints": {
                "type": "uint32",
                "id": 3,
                "rule": "optional"
              },
              "taxRateType": {
                "type": "squareup.common.feetypes.TaxRateType",
                "id": 7,
                "rule": "optional"
              },
              "costPlusFeeRate": {
                "type": "squareup.feeplans.CostPlusFeeRate",
                "id": 4,
                "rule": "optional"
              },
              "interchangePlusFeeRate": {
                "type": "squareup.feeplans.InterchangePlusFeeRate",
                "id": 13,
                "rule": "optional"
              },
              "supplementalFeeRate": {
                "type": "squareup.feeplans.SupplementalFeeRate",
                "id": 14,
                "rule": "optional"
              },
              "feePlanId": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "feePlanRateId": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "constraints": {
                "type": "squareup.feeplans.FeeRateConstraint",
                "id": 6,
                "rule": "repeated"
              },
              "auditLogs": {
                "type": "squareup.feeplans.AuditLogEntry",
                "id": 8,
                "rule": "repeated"
              },
              "taxRateDescription": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "additionalTaxRateCentiBps": {
                "type": "uint32",
                "id": 10,
                "rule": "optional"
              },
              "additionalTaxRateDescription": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              }
            }
          },
          "FeeplanDsl": {
            "fields": {
              "value": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "FeeRateConditions": {
            "fields": {
              "selector": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "entryMethod": {
                "type": "squareup.common.payment.EntryMethod",
                "id": 2,
                "rule": "optional"
              },
              "gatewayBucket": {
                "type": "squareup.feeplans.GatewayBucket",
                "id": 3,
                "rule": "optional"
              },
              "feeplanDsl": {
                "type": "squareup.feeplans.FeeplanDsl",
                "id": 4,
                "rule": "optional"
              },
              "buyerCurrencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "ConditionalFeeRate": {
            "fields": {
              "rate": {
                "type": "squareup.feeplans.TaxedFeeRate",
                "id": 1,
                "rule": "optional"
              },
              "feeRateConditions": {
                "type": "squareup.feeplans.FeeRateConditions",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "AuditLogEntry": {
            "fields": {
              "requesterOu": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "action": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "actorToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "reason": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "FeeRateEntry": {
            "fields": {
              "rate": {
                "type": "squareup.feeplans.TaxedFeeRate",
                "id": 1,
                "rule": "optional"
              },
              "feeRateId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "feePlanType": {
                "type": "squareup.common.feetypes.FeeplanType",
                "id": 3,
                "rule": "optional"
              },
              "product": {
                "type": "squareup.feeplans.model.FeePlanProduct",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "GatewayBucket": {
            "values": {
              "DO_NOT_USE": 0,
              "CAFIS_JCB": 1,
              "EVERLINK": 2,
              "ALL": 3,
              "CAFIS_DISCOVER_DINERS": 4,
              "ACH": 5,
              "EU_ISSUED_CARD": 6,
              "NON_EU_ISSUED_CARD": 7,
              "UNKNOWN_REGION": 8,
              "PAY_WITH_CASH": 9,
              "AFTERPAY": 10,
              "PAY_PAY": 11,
              "EMONEY_FELICA_ID": 12,
              "EMONEY_FELICA_QP": 13,
              "EMONEY_FELICA_TRANSPORTATION": 14,
              "DOMESTIC_ISSUED_CARD": 15,
              "EBT": 16,
              "OPEN_BANKING": 17,
              "RAKUTEN_PAY": 18,
              "MERPAY": 19,
              "AU_PAY": 20,
              "D_BARAI": 21,
              "WECHAT_PAY": 22,
              "ALIPAY": 23,
              "DGFT": 24,
              "BANK_TRANSFER": 25,
              "VISA": 26,
              "MASTERCARD": 27,
              "AMERICAN_EXPRESS": 28
            }
          },
          "TokenType": {
            "values": {
              "DEFAULT_DO_NOT_USE": 0,
              "UNIT": 1,
              "MERCHANT": 2,
              "PLATFORM": 3,
              "ORGANIZATION": 4
            }
          },
          "RefundPolicyInfo": {
            "fields": {
              "refundPolicyType": {
                "type": "squareup.common.RefundPolicyType",
                "id": 1,
                "rule": "optional"
              },
              "refundPolicy": {
                "type": "squareup.common.RefundPolicy",
                "id": 2,
                "rule": "optional"
              },
              "refundPolicyToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feeplans?.nested?.CostPlusFeeRate && !$root.nested?.squareup?.nested?.feeplans?.nested?.InterchangePlusFeeRate && !$root.nested?.squareup?.nested?.feeplans?.nested?.SupplementalFeeRate && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeeRateConstraint && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeeRateConstraint?.nested?.Type && !$root.nested?.squareup?.nested?.feeplans?.nested?.TaxedFeeRate && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeeplanDsl && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeeRateConditions && !$root.nested?.squareup?.nested?.feeplans?.nested?.ConditionalFeeRate && !$root.nested?.squareup?.nested?.feeplans?.nested?.AuditLogEntry && !$root.nested?.squareup?.nested?.feeplans?.nested?.FeeRateEntry && !$root.nested?.squareup?.nested?.feeplans?.nested?.GatewayBucket && !$root.nested?.squareup?.nested?.feeplans?.nested?.TokenType && !$root.nested?.squareup?.nested?.feeplans?.nested?.RefundPolicyInfo) {
  $root.addJSON(jsonData);
}

/**
 * A Cost+ fee rate.
 *
 * SOURCE CostPlusFeeRate @ squareup/feeplans/model.proto at 17:1
 */
export const CostPlusFeeRate = $root.lookupType('squareup.feeplans.CostPlusFeeRate');
fixType(CostPlusFeeRate, {
  marginBasisPoints: {
    required: true
  }
});
Builder.createAndAttachToType(CostPlusFeeRate);
/**
 * An Interchange+ fee rate.
 *
 * SOURCE InterchangePlusFeeRate @ squareup/feeplans/model.proto at 36:1
 */
export const InterchangePlusFeeRate = $root.lookupType('squareup.feeplans.InterchangePlusFeeRate');
fixType(InterchangePlusFeeRate, {
  marginBasisPoints: {
    required: true
  }
});
Builder.createAndAttachToType(InterchangePlusFeeRate);
/**
 * A Supplemental fee rate for IC+ or Cost+
 *
 * SOURCE SupplementalFeeRate @ squareup/feeplans/model.proto at 55:1
 */
export const SupplementalFeeRate = $root.lookupType('squareup.feeplans.SupplementalFeeRate');
fixType(SupplementalFeeRate, {
  marginBasisPoints: {
    required: true
  }
});
Builder.createAndAttachToType(SupplementalFeeRate);
/**
 * A constraint to be applied to a FeeRate
 *
 * SOURCE FeeRateConstraint @ squareup/feeplans/model.proto at 72:1
 */
export const FeeRateConstraint = $root.lookupType('squareup.feeplans.FeeRateConstraint');
fixType(FeeRateConstraint);
Builder.createAndAttachToType(FeeRateConstraint);
/**
 * SOURCE Type @ squareup/feeplans/model.proto at 73:3
 */
FeeRateConstraint.Type = $root.lookupEnum('squareup.feeplans.FeeRateConstraint.Type').values;
/**
 * A taxed fee rate representation, this has all the fields to calculate a fee for an amount
 *
 * SOURCE TaxedFeeRate @ squareup/feeplans/model.proto at 93:1
 */
export const TaxedFeeRate = $root.lookupType('squareup.feeplans.TaxedFeeRate');
fixType(TaxedFeeRate, {
  discountBasisPoints: {
    required: true
  },
  interchangeCents: {
    required: true
  },
  taxRateBasisPoints: {
    required: true
  }
});
Builder.createAndAttachToType(TaxedFeeRate);
/**
 * Message for allowing future extensibility of predicate_dsl.
 * Databse just has a predicate_dsl string, but this message allows us to add additional metadata
 * in future to the api
 *
 * SOURCE FeeplanDsl @ squareup/feeplans/model.proto at 141:1
 */
export const FeeplanDsl = $root.lookupType('squareup.feeplans.FeeplanDsl');
fixType(FeeplanDsl, {
  value: {
    required: true
  }
});
Builder.createAndAttachToType(FeeplanDsl);
/**
 * Optional conditions for selecting a TaxedFeeRate
 *
 * SOURCE FeeRateConditions @ squareup/feeplans/model.proto at 146:1
 */
export const FeeRateConditions = $root.lookupType('squareup.feeplans.FeeRateConditions');
fixType(FeeRateConditions);
Builder.createAndAttachToType(FeeRateConditions);
/**
 * A conditional rate, with selectors that define which rate to use for a specific payment
 *
 * SOURCE ConditionalFeeRate @ squareup/feeplans/model.proto at 158:1
 */
export const ConditionalFeeRate = $root.lookupType('squareup.feeplans.ConditionalFeeRate');
fixType(ConditionalFeeRate, {
  rate: {
    required: true
  }
});
Builder.createAndAttachToType(ConditionalFeeRate);
/**
 * Audit log for a FeePlan
 *
 * SOURCE AuditLogEntry @ squareup/feeplans/model.proto at 164:1
 */
export const AuditLogEntry = $root.lookupType('squareup.feeplans.AuditLogEntry');
fixType(AuditLogEntry);
Builder.createAndAttachToType(AuditLogEntry);
/**
 * SOURCE FeeRateEntry @ squareup/feeplans/model.proto at 172:1
 */
export const FeeRateEntry = $root.lookupType('squareup.feeplans.FeeRateEntry');
fixType(FeeRateEntry);
Builder.createAndAttachToType(FeeRateEntry);
/**
 * This enum loosely maps to the squareup.common.gateways.GatewayName. For fees there are only
 * a couple of gateways that we care about because we have to special price them.
 * To avoid blowing up the number of feeplans we need to create to model a custom
 * plan for Interac vs Amex/Visa/MC we model this as more of a credit vs debit flag rather
 * than enumerate the list of all the gateways.
 *
 * SOURCE GatewayBucket @ squareup/feeplans/model.proto at 193:1
 */
export const GatewayBucket = $root.lookupEnum('squareup.feeplans.GatewayBucket').values;
/**
 * The type of token a fee plan applies to.
 *
 * SOURCE TokenType @ squareup/feeplans/model.proto at 286:1
 */
export const TokenType = $root.lookupEnum('squareup.feeplans.TokenType').values;
/**
 * SOURCE RefundPolicyInfo @ squareup/feeplans/model.proto at 300:1
 */
export const RefundPolicyInfo = $root.lookupType('squareup.feeplans.RefundPolicyInfo');
fixType(RefundPolicyInfo);
Builder.createAndAttachToType(RefundPolicyInfo);